import { render, staticRenderFns } from "./AdmEditPix.vue?vue&type=template&id=6f0cd744&scoped=true&"
import script from "./AdmEditPix.vue?vue&type=script&lang=js&"
export * from "./AdmEditPix.vue?vue&type=script&lang=js&"
import style0 from "./AdmEditPix.vue?vue&type=style&index=0&id=6f0cd744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0cd744",
  null
  
)

export default component.exports